import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export function Footer() {
  const { content } = useContent();
  const d = content.doctor;
  const c = content.contact;
  const nav = [
    ["About", "about"], ["Expertise", "expertise"], ["Patient Information", "journey"],
    ["FAQs", "faq"], ["Contact", "contact"], ["Book / Enquire", "appointment"],
  ];
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-[#0A192F] text-white pt-24 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="w-11 h-11 rounded-full bg-white text-[#0A192F] grid place-items-center font-display text-2xl">R</span>
            <h3 className="font-display text-3xl mt-5">{d.name}</h3>
            <p className="text-white/60 mt-2">{d.specialty}</p>
            <p className="text-white/60">{d.institution}</p>
            <p className="text-white/60">{d.location}</p>
          </div>

          <div className="md:col-span-3">
            <span className="label text-white/40">Navigate</span>
            <ul className="mt-5 space-y-2.5">
              {nav.map(([label, id]) => (
                <li key={id}>
                  <button onClick={() => go(id)} className="text-white/70 hover:text-white transition-colors">{label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <span className="label text-white/40">Contact</span>
            <ul className="mt-5 space-y-2.5 text-white/70">
              <li>Phone: {c.phone}</li>
              <li>WhatsApp: {c.whatsapp}</li>
              <li>Email: {c.email}</li>
              <li className="text-white/50 text-sm">{c.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-wrap gap-6 text-sm text-white/60">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Terms</Link>
            <Link to="/medical-disclaimer" className="hover:text-white transition-colors" data-testid="footer-disclaimer">Medical Disclaimer</Link>
            <Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin">Admin</Link>
          </div>
          <p className="font-mono text-xs text-white/40">
            Website designed and developed by Catalyst Solutions.
          </p>
        </div>
      </div>
    </footer>
  );
}
